import React from "react";
import styled from "styled-components";
import { ReleaseDetailsFormProps } from "../types";
import {FormattedMessage} from "react-intl";
import { useLanguages } from "components/NewRelease/hooks/useLanguages";

const ReleaseDetailsForm: React.FC<ReleaseDetailsFormProps> = ({ releases }) => {
  const firstRelease = releases?.releases?.data;
  const truncateText = (value: any, max = 20) => {
    const s = String(value ?? "");
    if (s.length <= max) return s;
    return `${s.slice(0, max)}...`;
  };

  const {
    version = "—",
    title = "—",
    label,
    original_release_date = "—",
    release_date = "—",
    cline_value = "",
    pline_value = "",
    tracks = [],
    
  } = firstRelease || {};
  const hasPline = String(pline_value ?? "").trim().length > 0;
  const hasCline = String(cline_value ?? "").trim().length > 0;
  const showPlineCline = hasPline || hasCline;

const {languages}: { languages: { code: string; language: string }[] } = useLanguages();
const [leng, setLeng] = React.useState<string>("");

React.useEffect(() => {
  if (firstRelease?.tracks?.[0]?.metadata_language) {
    const lang = languages.find(
      (language) => language.code === firstRelease?.tracks?.[0]?.metadata_language
    );
    if (lang) {
      setLeng(lang.language);
    }
  }
}, [firstRelease, languages]);



  return (
    <Container>
      <Section>
        <SectionTitle>
          <FormattedMessage
            id="ReleaseDetails.ReleaseDetailsForm.ReleaseDetails"
            defaultMessage="Release details"
          />
        </SectionTitle>
        <FieldGroup>
          <Field>
            <FieldLabel>
              <FormattedMessage
                id="ReleaseDetails.ReleaseDetailsForm.ReleaseTitle"
                defaultMessage="Release title"
              />
            </FieldLabel>
            <FieldValue>{truncateText(title, 20)}</FieldValue>
          </Field>
          <Field>
            <FieldLabel>
              <FormattedMessage
                id="ReleaseDetails.ReleaseDetailsForm.ReleaseVersion"
                defaultMessage="Release version"
              />
            </FieldLabel>
            <FieldValue>{truncateText(version, 20)}</FieldValue>
          </Field>
          <Field>
            <FieldLabel>
              <FormattedMessage
                id="ReleaseDetails.ReleaseDetailsForm.Label"
                defaultMessage="Label"
              />
            </FieldLabel>
            <FieldValue>{label?.name}</FieldValue>
          </Field>
        </FieldGroup>
      </Section>

      {showPlineCline ? (
       <Section>
        <SectionTitle>
          <FormattedMessage
            id="ReleaseDetails.ReleaseDetailsForm.Copyright"
            defaultMessage="Copyright"
          />
        </SectionTitle>
        <FieldGroup>
          <Field>
            <FieldLabel>
              <FormattedMessage
                id="ReleaseDetails.ReleaseDetailsForm.PLine"
                defaultMessage="PLine"
              />
            </FieldLabel>
            <FieldValue>
              {/* <FormattedMessage
                id="ReleaseDetails.ReleaseDetailsForm.PLineValue"
                defaultMessage="XYZ Records (2023)"
              /> */}
              {String(pline_value ?? "").trim() || "—"}
            </FieldValue>
          </Field>
          <Field>
            <FieldLabel>
              <FormattedMessage
                id="ReleaseDetails.ReleaseDetailsForm.CLine"
                defaultMessage="CLine"
              />
            </FieldLabel>
            <FieldValue>
              {String(cline_value ?? "").trim() || "—"}
              {/* <FormattedMessage
                id="ReleaseDetails.ReleaseDetailsForm.CLineValue"
                defaultMessage="John Doe (2023)"
              /> */}
            </FieldValue>
          </Field>
        </FieldGroup>
      </Section>
      ) : null}

      <Section>
        <SectionTitle>
          <FormattedMessage
            id="ReleaseDetails.ReleaseDetailsForm.ReleaseDate"
            defaultMessage="Release date"
          />
        </SectionTitle>
        <FieldGroup>
          <Field>
            <FieldLabel>
              <FormattedMessage
                id="ReleaseDetails.ReleaseDetailsForm.ReleaseDate"
                defaultMessage="Release date"
              />
            </FieldLabel>
            <FieldValue>{release_date}</FieldValue>
          </Field>
          <Field>
            <FieldLabel>
              <FormattedMessage
                id="ReleaseDetails.ReleaseDetailsForm.OriginalReleaseDate"
                defaultMessage="Original release date"
              />
            </FieldLabel>
            <FieldValue>{original_release_date}</FieldValue>
          </Field>
        </FieldGroup>
      </Section>

      <Section>
        <SectionTitle>
          <FormattedMessage
            id="ReleaseDetails.ReleaseDetailsForm.Genre"
            defaultMessage="Genre"
          />
        </SectionTitle>
        <FieldGroup>
          <Field>
            <FieldLabel>
              <FormattedMessage
                id="ReleaseDetails.ReleaseDetailsForm.MainGenre"
                defaultMessage="Main genre"
              />
            </FieldLabel>
            <FieldValue> 
            {firstRelease?.genres?.find((g: { is_primary: number; }) => g.is_primary === 1)?.name}

             </FieldValue>
          </Field>
          <Field>
            <FieldLabel>
              <FormattedMessage
                id="ReleaseDetails.ReleaseDetailsForm.AdditionalGenres"
                defaultMessage="Additional genres"
              />
            </FieldLabel>
            <FieldValue> {(firstRelease?.genres ?? [])
  .filter((genre: { is_primary: number }) => genre.is_primary === 0)
  .map((genre: { id: React.Key | null | undefined; name: string | number | bigint | boolean | React.ReactElement<unknown, string | React.JSXElementConstructor<any>> | Iterable<React.ReactNode> | React.ReactPortal | Promise<string | number | bigint | boolean | React.ReactPortal | React.ReactElement<unknown, string | React.JSXElementConstructor<any>> | Iterable<React.ReactNode> | null | undefined> | null | undefined; }, index: number, arr: string | any[]) => (
    <span key={genre.id}>
      {genre.name}
      {arr.length - 1 !== index ? ", " : ""}
    </span>
  ))}

             </FieldValue>
          </Field>
        </FieldGroup>
      </Section>
    </Container>
  );
};
const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const Section = styled.div``;

const SectionTitle = styled.h3`
  margin: 14px 0 12px 0;
  font-weight: 600;
  font-size: 16px;
`;

const FieldGroup = styled.div`
  display: flex;
  gap: 20px;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 12px;
  }
`;

const Field = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  min-width: 200px;

  @media (max-width: 768px) {
    min-width: 0;
    width: 100%;
  }
`;

const FieldLabel = styled.span`
 
  color: #888;
  font-size: 14px;
`;

const FieldValue = styled.span`
  color: #000;
  font-weight: 500;
  font-size: 14px;
`;

export default ReleaseDetailsForm;
